<template>
  <v-content>
    <v-container class="fill-height mb-2" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-12" style="padding-bottom: 15px !important">
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>Welcome to Telfers</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-form>
                <v-text-field
                  label="Email"
                  name="login"
                  prepend-icon="mdi-email"
                  type="text"
                  v-model="email"
                  required
                ></v-text-field>
                <v-text-field
                  id="password"
                  :rules="[(v) => !!v || 'Password is required']"
                  label="Password"
                  name="password"
                  prepend-icon="mdi-lock"
                  type="password"
                  v-model="password"
                  @keyup.enter="login"
                  required
                  :append-icon="hidePassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="() => (hidePassword = !hidePassword)"
                  :type="hidePassword ? 'password' : 'text'"
                ></v-text-field>
              </v-form>
              <v-row class="pa-0">
                <v-col cols="12" class="pa-0">
                  <v-btn
                    block
                    color="green"
                    dark
                    :loading="loginLoading"
                    @click="login()"
                    >Login</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="forgotPasswordDialog" max-width="600px">
      <v-card>
        <v-card-text>
          <h2 class="py-2">Password reset</h2>
          <v-text-field
            label="Email"
            :rules="emailRules"
            name="login"
            prepend-icon="mdi-email"
            type="text"
            v-model="email"
            required
          ></v-text-field>
          <v-card-actions>
            <v-btn @click="forgotPasswordDialog = false">cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" dark @click="forgotPassword()"
              >Reset Password</v-btn
            >
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="newPasswordDialog" max-width="600px">
      <v-card>
        <v-card-text>
          <h2 class="py-2">New Password</h2>
          <p>
            Because this account was made by an Admin, your tempory password
            needs to be reset. To reset please type your Desired Password below
            and click confirm.
          </p>
          <v-text-field
            id="password"
            :rules="[(v) => !!v || 'Password is required']"
            label="Password"
            name="password"
            prepend-icon="mdi-lock"
            type="password"
            v-model="newPassword"
            @keyup.enter="changeMandatoryPassword"
            required
            :append-icon="hidePassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="() => (hidePassword = !hidePassword)"
            :type="hidePassword ? 'password' : 'text'"
          ></v-text-field>
          <v-card-actions>
            <v-btn
              :loading="changeTempPasswordLoading"
              color="primary"
              dark
              @click="changeMandatoryPassword()"
              >Confirm</v-btn
            >
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-content>
</template>

<script>
  import { mapGetters } from "vuex";
  import { auth } from "@/firebase.js";

  export default {
    computed: {
      ...mapGetters([
        "siteData",
        "currentUser",
        "currentUserData",
        "siteFirstLoad",
      ]),
    },
    data: () => ({
      forgotPasswordDialog: false,
      newPasswordDialog: false,
      newPassword: "",
      changeTempPasswordLoading: false,
      hidePassword: true,
      email: "",
      password: "",
      loginLoading: false,
      loginGoogleLoading: false,
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
    }),
    watch: {},
    mounted() {},
    methods: {
      login() {
        this.loginLoading = true;
        let _this = this;
        this.$cognitoAuth.authenticate(
          this.email,
          this.password,
          (err, result) => {
            if (err != null) {
              if (err.code == "NewPasswordRequired") {
                this.newMandatoryPassword();
              } else {
                this.$swal({
                  title: "Error",
                  text: err.message,
                  type: "error",
                  confirmButtonText: "Ok",
                });
              }
            } else {
              this.$store.dispatch("login", result);
            }
            this.loginLoading = false;
          }
        );
      },
      forgotPassword() {
        this.$store.dispatch("passwordReset", this.email);
        this.$swal({
          title: "Check your inbox",
          text:
            "If we find an account with your email address you will receive a password reset link via email.",
          type: "success",
          confirmButtonText: "Ok",
        });
        this.forgotPasswordDialog = false;
      },
      newMandatoryPassword() {
        this.newPasswordDialog = true;
      },
      changeMandatoryPassword() {
        this.changeTempPasswordLoading = true;
        this.$cognitoAuth.handleNewPassword(
          this.email,
          this.newPassword,
          (err, result) => {
            if (err != null) {
              this.$swal({
                title: "Error",
                text: err.message,
                type: "error",
                confirmButtonText: "Ok",
              });
            } else {
              this.$store.dispatch("initAuth");
            }
            this.changeTempPasswordLoading = false;
          }
        );
      },
    },
  };
</script>
